import axios from "@/axios"; 

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  async getOltDataPort(oltConnectId = null) {
    try {
      const user = JSON.parse(localStorage.getItem("user_data"));
      if (!user) throw new Error("User not found in localStorage");
      
      const url = API_URL + "/api/v1/sg-5/get-Olt_data_port/";
      const config = {
        headers: {
          'X-Custom-Header': user.id
        }
      };
      
      // Only add params if we have an ID
      if (oltConnectId) {
        config.params = { olt_connect_id: oltConnectId };
      }
      
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      console.error("Error in getOltDataPort:", error);
      throw error;
    }
  },

  async syncOltData(oltConnectId, syncType) {
    try {
      const user = JSON.parse(localStorage.getItem("user_data"));
      if (!user) throw new Error("User not found in localStorage");
      
      const url = API_URL + "/api/v1/sg-5/sync-olt-data/";
      const config = {
        headers: {
          'X-Custom-Header': user.id
        }
      };
      
      const data = {
        olt_connect_id: oltConnectId,
        sync_type: syncType
      };
      
      const response = await axios.post(url, data, config);
      return response.data;
    } catch (error) {
      console.error("Error in syncOltData:", error);
      throw error;
    }
  },

  async clearOltData(oltConnectId) {
    try {
      const user = JSON.parse(localStorage.getItem("user_data"));
      if (!user) throw new Error("User not found in localStorage");
      
      const url = API_URL + "/api/v1/sg-5/clear-olt-data/";
      const config = {
        headers: {
          'X-Custom-Header': user.id
        }
      };
      
      const data = {
        olt_connect_id: oltConnectId
      };
      
      const response = await axios.post(url, data, config);
      return response.data;
    } catch (error) {
      console.error("Error in clearOltData:", error);
      throw error;
    }
  },

  async oltSyncList() {
    try {
      const user = JSON.parse(localStorage.getItem("user_data"));
      if (!user) throw new Error("User not found in localStorage");
      
      const url = API_URL + "/api/v1/sg-5/olt-sync-list/";
      const config = {
        headers: {
          'X-Custom-Header': user.id
        }
      };
      
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      console.error("Error in oltSyncList:", error);
      throw error;
    }
  },

  async oltSyncAll(oltId, oltBrands, oltModes) {
    try {
      const user = JSON.parse(localStorage.getItem("user_data"));
      if (!user) throw new Error("User not found in localStorage");
      
      const url = API_URL + "/api/v1/sg-5/olt-sync-all/";
      const config = {
        headers: {
          'X-Custom-Header': user.id
        }
      };
      
      const data = {
        olt_id: oltId,
        olt_brands: oltBrands,
        olt_modes: oltModes
      };
      
      const response = await axios.post(url, data, config);
      return response.data;
    } catch (error) {
      console.error("Error in oltSyncAll:", error);
      throw error;
    }
  },

  async oltSync(oltId, oltBrands, syncType, oltModes) {
    try {
      const user = JSON.parse(localStorage.getItem("user_data"));
      if (!user) throw new Error("User not found in localStorage");
      
      const url = API_URL + "/api/v1/sg-5/olt-sync/";
      const config = {
        headers: {
          'X-Custom-Header': user.id
        }
      };
      
      const data = {
        olt_id: oltId,
        olt_brands: oltBrands,
        sync_type: syncType,
        olt_modes: oltModes
      };
      
      const response = await axios.post(url, data, config);
      return response.data;
    } catch (error) {
      console.error("Error in oltSync:", error);
      throw error;
    }
  },

  async oltSyncStatus(oltId) {
    try {
      const user = JSON.parse(localStorage.getItem("user_data"));
      if (!user) throw new Error("User not found in localStorage");
      
      const url = API_URL + "/api/v1/sg-5/olt-sync-status/";
      const config = {
        headers: {
          'X-Custom-Header': user.id
        },
        params: {
          olt_id: oltId
        }
      };
      
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      console.error("Error in oltSyncStatus:", error);
      throw error;
    }
  }
};
